<template>
  <v-layout row>
    <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
      <v-card class="mt-2 card-round card-login" rounded>
        <progress-bar :show="busy"></progress-bar>
        <v-card-title primary-title>
          <div class="form-title">
            <img src="/img/acma3.jpg" alt="alt" width="250" height="88" />
            <h3 class="title text-uppercase primary--text mb-0">Sign Up</h3>
          </div>
        </v-card-title>
        <form @submit.prevent="registerDeveloper" @keydown="form.onKeydown($event)">
          <v-card-text class="px-8">
            <!-- username -->
            <div class="form-field">
              <label>Username</label>
              <v-text-field v-model="form.username" solo counter="30" name="username" v-validate="'required|max:15'"
                :error-messages="errors.collect('username')" data-vv-name="username"></v-text-field>
            </div>

            <!-- Email -->
            <div class="form-field">
              <label for="email">Email </label>
              <v-text-field v-model="form.email" name="email" solo readonly disabled v-validate="'required|email'"
                data-vv-name="email" :error-messages="errors.collect('email')"></v-text-field>
            </div>

            <!-- Password -->
            <div class="form-field">
              <label for="email">Password </label>
              <password-input ref="password" :form="form" :hint="$t('password_length_hint')" :v-errors="errors"
                :value.sync="form.password" browser-autocomplete="new-password" v-on:eye="eye = $event" name="password"
                v-validate="'required|min:8'"></password-input>
            </div>

            <!-- Password Confirmation -->
            <div class="form-field">
              <label for="email">Confirm Password </label>
              <password-input :form="form" :hide="eye" :v-errors="errors" :value.sync="form.password_confirmation"
                browser-autocomplete="new-password" data-vv-as="password" hide-icon="true" name="password_confirmation"
                v-validate="'required|confirmed:password'"></password-input>
            </div>
            <div class="form-actions my-8">
              <submit-button :form="form" small :label="'Sign up'"></submit-button>
            </div>
          </v-card-text>
        </form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Form from "vform";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "developer-view",
  layout: "default",

  data: () => ({
    form: new Form({
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
    }),
    eye: true,
    busy: false,
  }),
  created() {
    this.token = this.$route.params.token;
    axios
      .get("/api/invitation/check/" + this.token)
      .then((response) => {
        this.form.email = response.data.email;
        this.form.token = this.token;
      })
      .catch((error) => console.log(error));
  },

  methods: {
    async registerDeveloper() {
      if (await this.formHasErrors()) return;
      this.busy = true;

      // Submit the form.
      await this.form.post("/api/invitation/accept");

      // Log in the user.
      const { data } = await this.form.post("/api/auth/login");

      // Save the token.
      this.$store.dispatch("saveToken", { token: data.access_token });

      // Fetch the user.
      await this.$store.dispatch("fetchUser");

      this.busy = false;
      // Redirect home.
      this.$router.push({ name: "overview" });
    },
  },
  beforeDestroy() {
    this.$validator.pause();
  },
};
</script>

<style scoped>
.card-login {
  box-shadow: 0px 10px 20px 5px rgba(0, 0, 0, 0.2);
}

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #78b943;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/developer.vue